export default __webpack_public_path__ + "img/landing.8150f1b0.jpg";